import React from "react";
import { Link } from "react-router-dom";
import { Megaphone, ArrowRight } from "lucide-react";

export default function CrossSellBanner() {
  return (
    <section className="max-w-7xl mx-auto px-6 md:px-12 py-10" data-testid="cross-sell-banner">
      <div className="relative overflow-hidden rounded-2xl border border-[#00F0FF]/25 bg-gradient-to-r from-[#0e1424] to-[#0b1a2e] p-8 md:p-10">
        <div className="absolute -right-10 -top-10 w-48 h-48 rounded-full bg-[#00F0FF]/10 blur-3xl" />
        <div className="relative flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div className="flex items-start gap-4">
            <div className="shrink-0 w-11 h-11 rounded-xl bg-[#00F0FF]/15 flex items-center justify-center">
              <Megaphone className="w-5 h-5 text-[#00F0FF]" />
            </div>
            <div>
              <h3 className="font-display font-bold text-xl md:text-2xl mb-1">Get your AI tool, job or event in front of our growing community</h3>
              <p className="text-sm text-[#94A3B8] max-w-2xl">
                Share what you're building with a growing community exploring the AI ecosystem.
                <span className="text-[#00F0FF] font-medium"> Free to post while we grow.</span>
              </p>
            </div>
          </div>
          <div className="flex flex-wrap gap-3">
            <Link to="/tools" data-testid="cross-sell-tool"
              className="inline-flex items-center gap-1.5 bg-[#00F0FF] text-[#04121a] font-semibold text-sm px-5 py-2.5 rounded-md hover:brightness-110 transition">
              List a Tool <ArrowRight className="w-4 h-4" />
            </Link>
            <Link to="/jobs" data-testid="cross-sell-job"
              className="inline-flex items-center gap-1.5 border border-white/15 text-sm px-5 py-2.5 rounded-md hover:border-[#00F0FF]/60 transition">
              Post a Job
            </Link>
            <Link to="/events" data-testid="cross-sell-event"
              className="inline-flex items-center gap-1.5 border border-white/15 text-sm px-5 py-2.5 rounded-md hover:border-[#00F0FF]/60 transition">
              Submit an Event
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
